import { useEffect } from 'react';
import { useAppSelector } from '../reducers';
import { experimentByTreatmentKeySelector } from '../selectors/ExperimentSelectors';
import { SSBU_0008_TREATMENT_KEY, SSBU_0008_GROUP_PARAMETER_OPTIONS } from '../constants/experimentKeys';
import useIsEligibleForFreeToProTouchlessFlow from '../components/interstitial/hooks/useIsEligibleForFreeToProTouchlessFlow';
import { getIsAcceptanceTest } from '../utils/testUtils';
import { logExposure } from '../utils/laboratoryClient';
const useIsCheckoutUIFreeToProEnabled = productConfigurations => {
  var _ssbu0008Experiment$p;
  const ssbu0008Experiment = useAppSelector(state => experimentByTreatmentKeySelector(state, SSBU_0008_TREATMENT_KEY));
  const isEligibleForFreeToProTouchlessFlow = useIsEligibleForFreeToProTouchlessFlow(productConfigurations);
  const isAcceptanceTest = getIsAcceptanceTest();
  const isExperimentInVariation = (ssbu0008Experiment === null || ssbu0008Experiment === void 0 || (_ssbu0008Experiment$p = ssbu0008Experiment.parameters) === null || _ssbu0008Experiment$p === void 0 ? void 0 : _ssbu0008Experiment$p.group) === SSBU_0008_GROUP_PARAMETER_OPTIONS.variation;
  const isCheckoutUIFreeToProEnabled = isExperimentInVariation && isEligibleForFreeToProTouchlessFlow && !isAcceptanceTest;
  useEffect(() => {
    if (isCheckoutUIFreeToProEnabled) {
      logExposure(SSBU_0008_TREATMENT_KEY);
    }
  }, [isCheckoutUIFreeToProEnabled]);
  return isCheckoutUIFreeToProEnabled;
};
export default useIsCheckoutUIFreeToProEnabled;